import React, { useContext } from "react";
import { GroupCard, Heading } from "../../utils/Module";
import { Button, Grid2, IconButton } from "@mui/material";
import DataContext from "../../Context/DataContext";


function FormSection( { sectionKey, title = "title", multiple, addNewRow, data = [], expand=false } ) {
  const { HandleDeleteRow } = useContext( DataContext );
  const [ isExpanded, setIsExpanded ] = React.useState( expand || false );

  const handleToggleExpand = () => {
    setIsExpanded( !isExpanded );
  }

  return (
    <div
      key={ sectionKey }
      style={ {
        border: "2px solid #b2babb",
        padding: "12px",
        margin: "12px 0",
        borderRadius: "12px",
      } }
    >
      <Heading
        key={ sectionKey }
        title={ title }
        variant="body1"
        color="gray"
        align="start"
        expand={expand}
        isExpanded={isExpanded}
        handleToggleExpand={ handleToggleExpand }
      />

      <Grid2
        key={ sectionKey }
        container
        spacing={ { xs: 1, md: 1 } }
        columns={ { xs: 2, sm: 4, md: 8 } }
      >
        { data?.map( ( section, index ) => {
          return (
            <>
              { data?.length > 1 && (
                <div style={ { width: "100%", textAlign: "end" } }>
                  <IconButton
                    sx={ { fontSize: "16px", fontWeight: "600", color: "red" } }
                    onClick={ ( e ) => HandleDeleteRow( e, section, index, title ) }
                  >
                    &#x2715;
                  </IconButton>
                </div>
              ) }
              <Grid2
                container
                spacing={ { xs: 1, md: 1 } }
                columns={ { xs: 2, sm: 4, md: 8 } }
              >
                { isExpanded ? null : GroupCard( section, index, multiple, title ) }
              </Grid2>
              { data?.length > 1 && (
                <hr style={ { width: "100%", margin: "12px 0" } } />
              ) }
            </>
          );
        } ) }
      </Grid2>
      {!isExpanded && multiple && (
        <div
          style={ { textAlign: "start", padding: "0px 0", fontWeight: "600" } }
        >
          <Button
            onClick={ ( e ) => addNewRow( e, title ) }
            variant="text"
            sx={ { fontWeight: "600" } }
          >
            + Add New
          </Button>
        </div>
      ) }
    </div>
  );
}

export default FormSection;
